import { Component, computed, DestroyRef, inject, input, signal } from '@angular/core';
import { Router, RouterLink, NavigationEnd } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, tap } from 'rxjs';

@Component({
    selector: 'app-menu-item',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.css'],
    imports: [RouterLink],
})
export class MenuItemComponent {
    private router = inject(Router);
    private destroyRef = inject(DestroyRef);

    label = input.required<string>();
    icon = input<string>();
    routerLink = input<string | unknown[]>();
    testId = input<string>();

    private currentUrl = signal(this.router.url.split(';')[0].split('?')[0]);

    isActive = computed(() => {
        const url = this.currentUrl();
        const link = this.routerLink();
        if (!link || typeof link !== 'string') return false;

        if (url === link) return true;

        // For non-add links: match view/edit routes but not /add
        if (!link.endsWith('/add') && url.startsWith(link + '/')) {
            return !url.includes('/add');
        }

        return false;
    });

    constructor() {
        this.router.events
            .pipe(
                filter((e) => e instanceof NavigationEnd),
                tap(() => this.currentUrl.set(this.router.url.split(';')[0].split('?')[0])),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe();
    }
}
